import { SIZE_50 } from '@/lib/gridElements/size';
import { totalLikesConfig } from '@/lib/analytics/kpis/youtube/totalLikes';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerLikesConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalLikesConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
